import { ManagedUser } from '@User/Data/DataSource/API/Entity/Identity'
import { identityAPI } from '@User/Data/DataSource/API/IdentityAPI'
import { useCallback, useEffect, useState } from 'react'

/** User management list, with Microsoft link state (`GET /identity/users`). */
export const useManagedUsers = () => {
    const [users, setUsers] = useState<ManagedUser[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const loadUsers = useCallback(async () => {
        setLoading(true)
        try {
            setUsers(await identityAPI.getManagedUsers())
        } catch (e) {
            console.error(e)
        }
        setLoading(false)
    }, [])

    useEffect(() => {
        loadUsers()
    }, [loadUsers])

    return {
        users,
        loading,
        reloadUsers: loadUsers,
    }
}
